import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../../app/service/proveedores/proveedores.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SpinnerService } from '../../../../app/service/spinner-service/spinner.service';
import { SuccessDialogComponent } from '../../success-dialog/success-dialog.component';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-alta-banco-proveedor-dialog',
  templateUrl: './alta-banco-proveedor-dialog.component.html',
  styleUrl: './alta-banco-proveedor-dialog.component.scss'
})
export class AltaBancoProveedorDialogComponent {
  
  pdfSrc: any
  proveedor: any
  empresasProveedor = ''
  loading = true

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any, 
      private proveedorService: ProveedoresService, 
      private spinnerService: SpinnerService,
      private sanitizer: DomSanitizer, 
      private dialog: MatDialog,
      public dialogRef: MatDialogRef<AltaBancoProveedorDialogComponent>){
    this.getProveedor(data.proveedor)
  }

  getProveedor(proveedor){
    this.proveedorService.getProveedorPorClave(proveedor.claveProveedor).subscribe(
      data => {
        this.proveedor = data[0]
        this.loading = false
        console.log(this.proveedor)
        this.proveedor.proveedorEmpresa.forEach((element, index) => {
          let empresa = index === 0 ? element.empresa : element.empresa + ',' 
          this.empresasProveedor = empresa
        });
        this.proveedor.documentosproveedor.forEach(element => {
          if(element.claveDocumento === 'CB'){
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }
        });
      }
    )
  }
  
  enviarValidacionCaratulaBancaria(opc){
    this.spinnerService.setMensaje('Guardando Cambios')
    this.spinnerService.show()
    let body = {
      proveedorId: this.proveedor.proveedorId,
      estatusAlta: opc,
      userAltaBanco: localStorage.getItem('id'),
      observacionesAltaBanco: ""
    }

      lastValueFrom(this.proveedorService.altaBancoProveedor(body)).then(
        data => {
          if(data.code === 200){
            const dialogRef = this.dialog.open(SuccessDialogComponent, {
              width: 'auto',
              data: {
                mensaje: data.message
              }
            });
          this.closeDialog()
          }else{
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto',
              data: {
                message: data.message
              }
              
            });
          }
          this.spinnerService.hide()
        }
      ).catch ( 
        err => {
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: 'auto',
            data: {
              isError: true,
              message: err.error.message
            }
            
          });

          this.spinnerService.hide()
        }
      )
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }
}
